import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'cashback', en);
i18next.addResources('fr', 'cashback', fr);

declare global {
  interface RegisteredLocales {
    cashback: typeof en;
  }
}
